
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/start_match",
      function () {
        return require("private-next-pages/manual/start_match.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/start_match"])
      });
    }
  